import React from "react";

import { Skeleton } from "@replo/design-system/components/skeleton/Skeleton";
import twMerge from "@replo/design-system/utils/twMerge";
import PreviewLoadingAnimation from "@v2/components/PreviewLoadingAnimation";

type PagePreviewProps = {
  cachedPageHtml: string | undefined;
  isLoadingPage: boolean;
  isInteractive: boolean;
  isScrollable: boolean;
  hideScrollbars?: boolean;
};

const PagePreview: React.FC<PagePreviewProps> = ({
  cachedPageHtml,
  isLoadingPage,
  isInteractive,
  isScrollable,
  hideScrollbars,
}) => {
  // NOTE (Gabe 2025-07-23): This means the cachedContent is loading.
  if (cachedPageHtml === undefined) {
    return null;
  }
  return (
    <>
      {!cachedPageHtml &&
        isLoadingPage &&
        (isInteractive ? (
          <PreviewLoadingAnimation className="absolute" />
        ) : (
          <Skeleton className="h-full w-full rounded absolute " />
        ))}
      {/* This is a static iframe that is used to display the cached version of the page */}
      {cachedPageHtml && (isLoadingPage || !isInteractive) && (
        <div
          className={twMerge(
            "h-full w-full absolute",
            hideScrollbars && isScrollable && "overflow-hidden",
          )}
        >
          <iframe
            srcDoc={cachedPageHtml}
            className={twMerge(
              "h-full border-0",
              hideScrollbars && isScrollable ? "w-[calc(100%+20px)]" : "w-full",
              isInteractive && "opacity-60",
            )}
            scrolling={isScrollable ? "auto" : "no"}
            // NOTE (Ben 2025-07-17): This is needed to prevent the iframe from being included in window
            // history and messing up navigation.
            sandbox="allow-same-origin"
          />
        </div>
      )}
    </>
  );
};

export default PagePreview;
